import { StyleSheet } from 'react-native';

import { onPressCondition } from '@/app/(app)';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

import Text from './Text';

const TermsPrivacyText = () => {
  const colors = useColor();

  //Locales
  const firstTermsText = i18n.t('sign_in.individual.phone_sign_in.first_terms');
  const termsLink = i18n.t('mix.terms');
  const andText = i18n.t('mix.and');
  const privacyLink = i18n.t('mix.privacy');
  const secondTermsText = i18n.t('sign_in.individual.phone_sign_in.second_terms');

  return (
    <Text>
      {firstTermsText}{' '}
      <Text
        fontWeight="700"
        onPress={() => onPressCondition('tos')}
        style={[styles.linkText, { color: colors.linkText }]}>
        {termsLink}{' '}
      </Text>
      {andText}{' '}
      <Text
        fontWeight="700"
        onPress={() => onPressCondition('pp')}
        style={[styles.linkText, { color: colors.linkText }]}>
        {privacyLink}
      </Text>
      {secondTermsText}
    </Text>
  );
};

const styles = StyleSheet.create({
  linkText: {
    fontSize: 14
  }
});

export default TermsPrivacyText;
